import React from "react";
import ourStoryImg from '../../../assets/images/ourStoryImg.png'

const OurStory = () => {
  return (
    <div className="max-w-1200 mx-auto w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-10 xl:gap-52 justify-between">
      <div className="lg:w-1/2 flex-1">
        <p className="text-darkPurple text-sm uppercase font-bold mb-2">
          Our Story
        </p>
        <p className="text-[#374151] text-lg xl:pr-2">
          RegTechFlow was born out of the real frustrations faced by corporate
          and compliance professionals. While the work itself is rewarding, the
          never-ending paperwork—due diligence forms, license applications,
          renewals and endless filings_quickly becomes overwhelming,
          time-consuming, and repetitive. In a fast-growing world where
          technology is simplifying lives, we knew compliance management should
          be no different. With that vision, we created RegTechFlow to automate
          up to 75% of corporate and license management, giving professionals
          across industries more time to focus on what truly matters: Growing
          their business.
        </p>
      </div>
      <div className="w-full lg:w-[411px] h-[241px] sm:h-[380px] lg:h-[364px]">
        <img src={ourStoryImg} alt='story-img' className="size-full lg:block rounded-xl" />
      </div>
    </div>
  );
};

export default OurStory;
